import React, { useState, useEffect } from 'react'
import axios from '~/data/http/axios';
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1';
import WarningHolder from '~/Common-Objects/UI/Cards/WarningHolder';

export default function TwitterConnect({ }) {
    const [error, setError] = useState(null)

    useEffect(() => {
        axios.get('/application/twitter/authlink').then(res => {
            if (res.data.url) window.location = res.data.url
            else {
                setError('Something went wrong. Please try again later.')
            }
        }).catch(e => {
            console.log(e)
            setError('Something went wrong. Please try again later.')
        })
    }, [])

    return (
        <div>
            {!error && <LoadingIcons />}
            {!!error && <WarningHolder>{error}</WarningHolder>}
        </div>
    )
}